import * as React from "react";
import SimpleButton from "../../RenderComponents/SimpleButton";

interface IProps {
    isAdmin: boolean;
    onClick: () => void;
    type?: "a" | "button";
    text?: string;
    title?: string;
    ariaLabel?: string;
    showIcon?: boolean;
}

const SettingsButton = (props: IProps) => {
    return props.isAdmin ? (
        <SimpleButton
            className="CMS_button CMS_bAction"
            type={props.type}
            title={props.title}
            ariaLabel={props.ariaLabel}
            href={"#"}
            onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                props.onClick();
            }}
        >
            {props.showIcon ? <em className="fa fa-cog" aria-hidden="true"></em> : null} {props.text || "Settings"}
        </SimpleButton>
    ) : null;
};

export default SettingsButton;
